<template>
  <div>
    <PageHeader>
      <template v-slot:header>パスワード変更</template>
      <template v-slot:annotation>
        パスワードを変更する場合は、変更後のパスワードを入力後、変更ボタンをクリックしてください。
      </template>
    </PageHeader>

    <v-form ref="password_form">
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <FormInputComponent
            label="現在のパスワード"
            type="password"
            v-model="currentPassword"
            rules="passwordRules"
            :counter="8"
          />

          <FormInputComponent
            label="変更後のパスワード"
            type="password"
            v-model="changePassword"
            rules="passwordRules"
            :counter="8"
          />

          <FormInputComponent
            label="変更後のパスワード（再）"
            type="password"
            v-model="changePasswordRetry"
            rules="passwordRules"
            :counter="8"
          />
        </v-col>
      </v-row>
    </v-form>
    <Button @click="erntry_confirm" color="primary" :disabled="loading"
      >変更</Button
    >

    <Loader :loading="loading" />

    <ConfirmDialog
      ref="confirm"
      title="パスワード変更"
      :message="confirmMessage"
      buttonMessage="OK"
      @confirm="editPasswordInfo"
    >
    </ConfirmDialog>

    <ConfirmDialog
      ref="confirm_done"
      title="パスワード変更完了"
      :message="confirmMessage"
      buttonMessage="OK"
      @confirm="passwordChangeDone"
    >
    </ConfirmDialog>

    <DialogMessage ref="dialog" />
  </div>
</template>

<script>
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import {
  getSessionStorageItem,
  encrypt256,
  deleteLoginCookie,
} from '../../../common.js';
export default {
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      // 変数宣言
      showContent: false,
      loading: false,
      confirmMessage: null,
      password: null,
      currentPassword: '',
      changePassword: '',
      changePasswordRetry: '',
    };
  },
  created() {
    // 現在のパスワード設定
    let userInfo = getSessionStorageItem();
    this.initialPassword = userInfo.INITIAL_PASSWORD;
    this.password = userInfo.PASSWORD;
    this.currentPassword = '';
    this.changePassword = '';
    this.changePasswordRetry = '';
  },

  methods: {
    erntry_confirm() {
      // 入力チェック
      if (!this.$refs.password_form.validate()) {
        return;
      }
      // 現在のパスワードチェック
      if (this.password != encrypt256(this.currentPassword)) {
        this.$refs.dialog.open(
          'info',
          '現在のパスワードが違います。\n ご確認の上、再度、現在のパスワードをご入力下さい。'
        );
        return;
      }
      // 変更後パスワードチェック
      if (this.changePassword != this.changePasswordRetry) {
        this.$refs.dialog.open(
          'info',
          '変更後のパスワードと変更後のパスワード(再)の入力値が違います。\n 再度、変更後のパスワードをご入力下さい。'
        );
        return;
      }

      // 初期パスワードチェック
      if (this.initialPassword == encrypt256(this.changePassword)) {
        this.$refs.dialog.open(
          'info',
          '入力されたパスワードは初期パスワードです。\n 再度、初期パスワードとは違うパスワードをご入力下さい。'
        );
        return;
      }

      // 確認ダイアログ表示
      this.confirmMessage = 'パスワードを変更しますか？';
      this.$refs.confirm.open();
    },
    editPasswordInfo() {
      // ローディング画像表示
      this.loading = false;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // パスワード設定
      let originalPassword = this.password.substr(0, 10);
      // パスワード設定
      if (originalPassword != this.changePassword) {
        this.password = encrypt256(this.changePassword);
      }

      //----- パスワード変更リクエストPOST
      axios
        .post(config.CONNECT_URL + '/Encouragements/password', {
          SESSION_ID: userInfo.SESSION_ID,
          USER_ID: userInfo.USER_ID,
          PASSWORD: this.password,
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          if (response.status == 200) {
            // Cookieのログイン情報削除
            deleteLoginCookie();

            // 確認ダイアログ表示
            this.confirmMessage = message.MSG_INFO_PASSWORD_ENTRY_COMPLETE;
            this.$refs.confirm_done.open();
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    passwordChangeDone() {
      // ログイン画面に戻る
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>
